import React from 'react';
import ReactGA from 'react-ga';
import imgUrl from '../../assets/gie-logo-bg-3.jpg';
import EmergencyFormDetail from './EmergencyFormDetail';
import EmergencyDescription from './EmergencyDescription';
import MessageSuccess from '../../components/form/MessageSuccess';
import EmergencyController from '../../controller/emergency.controller';
import {WebEventUtil} from '../../util/web-event-util';
import {I18n} from '../../util/i18n';
import userInformations from '../../userInformation/user_informations';
import TitleListScreen from "../../components/TitleListeScreen/TitleListScreen";
import GIEServicesContainer from "../../components/GIEServicesContainer/GIEServicesContainer";
import NoticeForList from "../../components/GIEList/NoticeForList";
import GieCard from "../../components/GIECard/GieCard";
import HeaderForm from "../../components/form/HeaderForm";

export default class EmergencyForm extends React.Component<any, any> {

  emergencyController: EmergencyController = new EmergencyController();

  constructor(props: any) {
    super(props);
    this.state = {
      step: 0,
      isSend: false,
      description: '',
      nature: ''
    }
  }

  componentDidMount() {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  setDataStep1 = data => {
    const description = data.description.value;
    const nature = data.nature.value;
    this.setState({description, nature});
    this.next();
  }

  next = () => {
    this.setState({step: this.state.step + 1})
  }

  previous = () => {
    this.setState({step: this.state.step - 1})
  }

  sendData = (form, callback) => {
    let contactDetailEmergency: any = {};
    Object.keys(form).forEach((name, key) => {
      contactDetailEmergency[name] = form[name].value
    });
    const noContract = userInformations.getNoContract();
    if (!noContract?.length) {
      window.location.href = "/admin/login"
    } else {
      contactDetailEmergency.breakDownDescription = this.state.description;
      const i18nFile: any = I18n.getFile();

      const nature = i18nFile[this.state.nature] != null ? i18nFile[this.state.nature] : this.state.nature;
      contactDetailEmergency.nature = nature

      const request = {
        noContrat: noContract,
        eventType: "3",
        eventCode: 'URGENCE',
        description: "Signaler une panne",
        confirm: '0',
        mail_object: WebEventUtil.getBodyOfEmail(contactDetailEmergency),
        noClient: null,
        codeSite: null,
        hour: new Date().getHours(),
        contactDetailEmergency: contactDetailEmergency
      }
      this.emergencyController.sendEmergency(request).then(data => {
        this.next();
      }).catch(err => {
        console.error(err)
      }).finally(() => {
        callback();
      })
    }
  }

  render() {
    return (
      <div className="content">
        <GIEServicesContainer imgUrl={imgUrl} title={<TitleListScreen miniTitle="Signaler une panne"
                                                                      href="formulaire-d-urgence"
                                                                      title="Transmettez-nous votre demande"/>}>
          <div className="container-xl mb-5">
            {this.state.step < 2 && <NoticeForList className="mb-3"
                                                   text="Grâce à votre contrat d’entretien, vous bénéficiez d’un accès prioritaire au dépannage pour toujours plus de confort et de sérénité, et ce, toute l’année."/>}
            <GieCard width="100%" height="100%">
              {this.state.step < 2 && <HeaderForm step={this.state.step}
                                                  first="1 - Identification de la panne"
                                                  second="2 - Vos coordonnées"/>}
              {this.state.step === 0 && <EmergencyDescription next={this.setDataStep1}/>}
              {this.state.step === 1 && <EmergencyFormDetail previous={this.previous} emit={this.sendData}/>}
              {this.state.step === 2 && <MessageSuccess/>}
            </GieCard>
          </div>
        </GIEServicesContainer>
      </div>
    );
  }
}
